import { create } from "zustand";
import { RECEIPT_DISCOUNT_TYPE } from "../../constants/receipt";
import { ReceiptStore } from "./types";
import { defaultPayMode } from "./utils";

const useReceiptStore = create<ReceiptStore>((set, get) => ({
  aid: null,
  receiptId: null,
  receiptState: "",

  receipt: null,
  setReceipt: receipt => {
    set({ receipt });
  },

  setReceiptPopupData: receiptPopupData => {
    set(receiptPopupData);
  },

  setCloseReceiptPopup: () => {
    set(() => ({
      patientName: "",
      phoneNumber: "",
      uhid: "",
      services: [],
      receiptId: null,
      receiptUrl: null,
      receipt: null,
      aid: null,
      payModes: [],
      discountOnTotal: {
        discount: 0,
        discountToShowWithType: "0",
        discountType: RECEIPT_DISCOUNT_TYPE[0],
      },
      createReceiptDisabled: false,
      receiptState: "",
    }));
  },
  setReceiptState: receiptState => {
    set({
      receiptState,
    });
  },

  patientName: "",
  setPatientName: patientName => {
    set(() => ({ patientName }));
  },

  uhid: "",
  setUhid: uhid => {
    if (uhid) {
      set(() => ({ uhid }));
    }
  },

  phoneNumber: "",
  setPhoneNumber: phoneNumber => {
    set({ phoneNumber });
  },

  services: [],
  setServices: services => {
    if (services) {
      set(() => ({ services }));
    }
  },

  patientId: "",
  clinicId: "",

  patient: null,

  payModes: [defaultPayMode({})],
  setPayModes: payModes => {
    if (payModes) {
      set(() => ({ payModes }));
    }
  },

  discountOnTotal: {
    discount: 0,
    discountToShowWithType: "0",
    discountType: RECEIPT_DISCOUNT_TYPE[0],
  },
  setDiscountOnTotal: discountOnTotal => {
    if (discountOnTotal) {
      set(() => ({ discountOnTotal }));
    }
  },

  createReceiptDisabled: false,
  setCreateReceiptDisabled: createReceiptDisabled => {
    set(() => ({ createReceiptDisabled }));
  },
  patientOwes: 0,
  setPatientOwes: patientOwes =>
    set({ patientOwes, amountSettled: patientOwes }),

  amountSettled: 0,
  setAmountSettled: amountSettled => set({ amountSettled }),

  closeSettleDuePopupAction: "CLOSE",
  setCloseSettleDuePopupAction: action =>
    set({ closeSettleDuePopupAction: action }),
}));

export default useReceiptStore;
